(() => {
  'use strict';
  const text = window.welanorCommerceText || {};
  const selectedCount = n => (n === 1 ? text.selectedOne : text.selectedMany || '').replace('{count}', String(n));
  const money = (cents, element) => new Intl.NumberFormat(element.dataset.locale || document.documentElement.lang || 'de', {
    style: 'currency', currency: element.dataset.currency || 'EUR'
  }).format(cents / 100);

  document.querySelectorAll('[data-atlas-routine]').forEach(form => {
    const ledger = form.querySelector('[data-selection-ledger]');
    if (!ledger) return;
    const rows = [...form.querySelectorAll('[data-atlas-product]')];
    const checkboxes = rows.map(row => row.querySelector('[data-atlas-product-toggle]')).filter(Boolean);
    const update = () => {
      const selected = rows.filter(row => row.dataset.available === 'true' && row.querySelector('[data-atlas-product-toggle]')?.checked);
      const sum = selected.reduce((total, row) => total + (Number(row.dataset.priceCents) || 0), 0);
      ledger.querySelector('[data-selection-count]').textContent = selectedCount(selected.length);
      ledger.querySelector('[data-selection-total]').textContent = money(sum, ledger);
      form.querySelector('[data-atlas-add-all]').disabled = selected.length === 0;
    };
    form.addEventListener('change', update);
    ledger.querySelector('[data-selection-all]').addEventListener('click', () => { checkboxes.forEach(c => { c.checked = !c.disabled; }); update(); });
    ledger.querySelector('[data-selection-clear]').addEventListener('click', () => { checkboxes.forEach(c => { c.checked = false; }); update(); });
    update();
  });

  document.querySelectorAll('[data-look-summary]').forEach(summary => {
    const look = summary.closest('[data-look]');
    const rows = [...look.querySelectorAll('[data-look-row][data-variant-id]')];
    const sum = rows.reduce((total, row) => total + (Number(row.dataset.priceCents) || 0), 0);
    summary.textContent = `${selectedCount(rows.length)} · ${money(sum, summary)} · ${text.priceNote}`;
    const button = look.querySelector('[data-look-addall]');
    if (button) button.disabled = rows.length === 0;
  });

  // The app owns pricing and add-to-cart. Native controls remain the fallback.
  document.querySelectorAll('[data-pdp]').forEach(root => {
    const native = root.querySelector('.mareclo-pdp__atc');
    const sync = () => {
      const appButton = root.querySelector('.mareclo-pdp__app [data-tierup-add]');
      const ready = Boolean(appButton && !appButton.hidden && getComputedStyle(appButton).display !== 'none');
      root.classList.toggle('v4-tierup-ready', ready);
      if (native) native.hidden = ready;
    };
    const observer = new MutationObserver(sync);
    root.querySelectorAll('.mareclo-pdp__app').forEach(app => observer.observe(app, { subtree: true, childList: true, attributes: true }));
    sync();
    window.addEventListener('pageshow', sync);
  });

  // Native Shopify forms filter the whole collection, not only loaded cards.
  document.querySelectorAll('[data-catalog-filters]').forEach(form => {
    const params = new URLSearchParams(location.search);
    for (const key of ['preview_theme_id', 'view']) {
      if (!params.has(key)) continue;
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = key; input.value = params.get(key); form.appendChild(input);
    }
    // Mobile: "Filter" opens the panel; the sort select submits on change because the
    // apply button sits inside that panel. Desktop keeps the toggle hidden (no change).
    const toggle = form.querySelector('[data-filter-toggle]');
    const panel = form.querySelector('[data-filter-panel]');
    const compact = () => Boolean(toggle) && getComputedStyle(toggle).display !== 'none';
    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        const open = !panel.classList.contains('is-open');
        panel.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        if (open) panel.querySelector('summary, input, button')?.focus({ preventScroll: true });
      });
    }
    form.querySelector('select[name="sort_by"]')?.addEventListener('change', () => {
      if (compact()) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
})();
